import service from './server';
export default {
    //视频资料-查询所有
    listVideo(params) {
        return service.post('api_zh/video/listVideo', params)
    }, 
    //应聘管理-申请加入
    addApplicant(params) {
        return service.post('api_form_zh/applicant/addApplicant', params)
    }, 
    //白皮书
    whitePaper(params) {
        return service.post('api_zh/whitePaper/getUrl', params)
    }, 
    //查询原子币价格
    findPrice(params) {
        return service.post('api_zh/price/findPrice', params)
    }, 
    ////团队成员-查询所有
    listTeamMembers(params) {
        return service.post('api_zh/teamMembers/listTeamMembers', params)
    }, 
    //关于我们-查询所有
    listAboutUs(params) {
        return service.post('api_zh/aboutUs/listAboutUs', params)
    }, 
    //常见问题-查询所有
    listCommonProblem(params) {
        return service.post('api_zh/commonProblem/listCommonProblem', params)
    }, 
    //企业文化-查询所有
    listCultureFolder(params) {
        return service.post('api_zh/cultureFolder/listCultureFolder', params)
    }, 
    //音频资料-查询所有
    listAudio(params) {
        return service.post('api_zh/audio/listAudio', params)
    },
    //企业文化-查询所有----相册里面
    listByCultureFolderId(params) {
        return service.post('api_zh/cultureFolder/listByCultureFolderId', params)
    },
    //新闻资讯-查询所有
    listNews(params) {
        return service.post('api_zh/news/listNews', params)
    },
    //音频
    findAudioById(params) {
        return service.post('api_zh/audio/findAudioById', params)
    },
    //获取职位
    listPost(params) {
        return service.post('api_zh/post/listPost', params)
    },
    //新闻详情
    findNewsById(params) {
        return service.post('api_zh/news/findNewsById', params)
    },

    audioSet(params) {
        return service.post('api_zh/audio/audioSet', params)
    },
    findTeamMembersById(params) {
        return service.post('api_zh/teamMembers/findTeamMembersById', params)
    },
    videoSet(params) {
        return service.post('api_zh/video/videoSet', params)
    },
    // 跳转IP判断
    // chinaIpJudge(params) {
    //     return service.post('api_intapi_zh/h5/chinaIp', params)
    // },
    chinaIpJudge2(params)
    {
        return service.get('judgeIp/intapi/h5/ipFrom', params);
    },
    // -----------英文-----------英文-----------英文-----------------------------------------------------
    //视频资料-查询所有
    listVideoEn(params) {
        return service.post('api_en/video/listVideo', params)
    }, 
    //白皮书
    whitePaperEn(params) {
        return service.post('api_en/whitePaper/getUrl', params)
    }, 
    ////团队成员-查询所有
    listTeamMembersEn(params) {
        return service.post('api_en/teamMembers/listTeamMembers', params)
    }, 
    //常见问题-查询所有
    listCommonProblemEn(params) {
        return service.post('api_en/commonProblem/listCommonProblem', params)
    }, 
    //音频资料-查询所有
    listAudioEn(params) {
        return service.post('api_en/audio/listAudio', params)
    },
    //企业文化-查询所有
    listCultureFolderEn(params) {
        return service.post('api_en/cultureFolder/listCultureFolder', params)
    }, 
    //新闻资讯-查询所有
    listNewsEn(params) {
        return service.post('api_en/news/listNews', params)
    },
    //企业文化-查询所有----相册里面
    listByCultureFolderIdEn(params) {
        return service.post('api_en/cultureFolder/listByCultureFolderId', params)
    },
    //新闻详情
    findNewsByIdEn(params) {
        return service.post('api_en/news/findNewsById', params)
    },
    //音频
    findAudioByIdEn(params) {
        return service.post('api_en/audio/findAudioById', params)
    },
    
    audioSetEn(params) {
        return service.post('api_en/audio/audioSet', params)
    },
    findTeamMembersByIdEn(params) {
        return service.post('api_en/teamMembers/findTeamMembersById', params)
    },
    videoSetEn(params) {
        return service.post('api_en/video/videoSet', params)
    },
    // 20220827  今日访问地址
    findTodayUrl(params) {
        return service.get('api_zh/doMain/findDoMainList', params)
    },
    
}



// WEBPACK FOOTER //
// ./src/server/index.js